import {AppRouter} from '@app/providers/AppRouter';

export const AppRouterWrapper = () => {
  return <AppRouter />;
};
